// @core/api/endpoints/activity/list_decisions.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListDecisionsResponse,
} from '../../../types/activity';

const BASE_PATH = '/activity';

/**
 * List decisions
 * Returns the decision journal: all DECISION activities filtered by scope (project, team, tenant). Useful for understanding why things were decided.
 */
export async function ListDecisions(
  params?: {
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    limit?: string | number | boolean;
    object_id?: string | number | boolean;
    scope?: string | number | boolean;
    scope_id?: string | number | boolean;
    sort?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListDecisionsResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/decisions`;
  const requestOptions = options;
  return client.get<ListDecisionsResponse>(requestPath, { ...requestOptions, params });
}
